import React from 'react'
import Svg from './Svg'
export const SvgArrowRight = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path stroke="inherit" strokeMiterlimit={10} d="M6.333.15l11.772 11.773L6.333 23.695" />
  </Svg>
))
SvgArrowRight.isIcon = true
export default SvgArrowRight
